import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import userPropTypes from '../../../userPropTypes.js';
import autoPayoutFormatter from '../autoPayoutFormatter.js';

function getContent(user) {
    const hasAutoPayout = autoPayoutFormatter(user.bankAccounts);
    return hasAutoPayout ? 'Send varen' : 'Send varen og oppgi bankkonto';
}

const PaidSummary = ({ partner, user }) => (
    <StatusSummaryButton
        href="/send-varen"
        statusSummary={`${partner.name} har betalt til FINN.`}
        actionRequiredType="POSITIVE"
    >
        {getContent(user)}
    </StatusSummaryButton>
);

PaidSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    user: userPropTypes.isRequired,
};

export default PaidSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/summaries/paidSummary.jsx